export const defaultProductList = [
    'Rammelån',
    'Lån til fritidsbolig',
    'Finansieringsbevis (til deg uten egen bolig eller lån)',
    'Kun digitalt kort',
    'Forsikringer',
    'Fond',
    'Barnekonto',
    'Barnekort',
    'BSU',
    'Depositumskonto',
    'Annet',
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZHVjdExpc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9hY3F1YWludGFuY2UtZm9ybS9wcm9kdWN0TGlzdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRztJQUM5QixVQUFVO0lBQ1Ysc0JBQXNCO0lBQ3RCLHdEQUF3RDtJQUN4RCxtQkFBbUI7SUFDbkIsY0FBYztJQUNkLE1BQU07SUFDTixZQUFZO0lBQ1osV0FBVztJQUNYLEtBQUs7SUFDTCxpQkFBaUI7SUFDakIsT0FBTztDQUNWLENBQUMifQ==